import { lazy } from 'react'
import ProtectedRoute from "../components/ProtectedRoute"
import Invite from "../pages/invite";

const Calendar = lazy(() => import('../pages/calendar'))
const Teams = lazy(() => import('../pages/teams'))
const Deductions = lazy(() => import('../pages/deductions'))
const Department = lazy(() => import('../pages/department'))
const Documents = lazy(() => import('../pages/documents'))
const Report = lazy(() => import('../pages/reports'))
const JobPage = lazy(() => import('../pages/job'))
const OverView = lazy(() => import('../pages/overview'))
const Employees = lazy(() => import('../pages/employees'))
const Settings = lazy(() => import('../pages/settings'))
const Requests = lazy(() => import('../pages/requests'))
const Chat = lazy(() => import('../pages/chats'))
const Clients = lazy(() => import('../pages/employees/clients'))
const ServiceProviders = lazy(() => import('../pages/employees/service providers'))
const CareSignals = lazy(() => import('../pages/care-signals'))

// Dynamic routes
const DynamicDepartment = lazy(() => import('../pages/dynamics/department'))
const DynamicTeam = lazy(() => import('../pages/dynamics/team'))
const DynamicEmployee = lazy(() => import('../pages/dynamics/employee'))
const DynamicRequest = lazy(() => import('../pages/dynamics/request'))
const DynamicSession = lazy(() => import('../pages/dynamics/session'))
const DynamicApplication = lazy(() => import('../pages/dynamics/application'))
const DynamicRating = lazy(() => import('../pages/dynamics/rating'))

const Payroll = lazy(() => import('../pages/payroll'))
const PayrollSchedule = lazy(() => import('../pages/payroll/settings/schedule'))
const PayrollAccount = lazy(() => import('../pages/payroll/settings/account'))
const PayrollSaveCard = lazy(() => import('../pages/payroll/settings/account/collect_card'))
const PayrollSetup = lazy(() => import('../pages/payroll/run/setup'))

const PayrollDetails = lazy(() => import('../pages/payroll/history/details'))

const Invoice = lazy(() => import('../pages/invoicing'))
const InvoiceDetail = lazy(() => import('../pages/invoicing/detail'))

export const AdminRoutes = [
    { path: "calendar", element: <ProtectedRoute children={<Calendar />} /> },
    { path: "team", element: <ProtectedRoute children={<Teams />} />, },
    { path: "team/:teamId", element: <ProtectedRoute children={<DynamicTeam />} /> },
    { path: "deductions", element: <ProtectedRoute children={<Deductions />} />, },
    { path: "documents", element: <ProtectedRoute children={<Documents />} />, },
    { path: "report", element: <ProtectedRoute children={<Report />} />, },
    { path: "department", element: <ProtectedRoute children={<Department />} />, },
    { path: "department/:departmentId", element: <ProtectedRoute children={<DynamicDepartment />} /> },
    { path: "jobs", element: <ProtectedRoute children={<JobPage />} /> },
    { path: "overview", element: <ProtectedRoute children={<OverView />} /> },
    { path: "clients", element: <ProtectedRoute children={<Clients />} /> },
    { path: "service-providers", element: <ProtectedRoute children={<ServiceProviders />} /> },
    { path: "staff", element: <ProtectedRoute children={<Employees />} /> },
    { path: "nurses", element: <ProtectedRoute children={<Employees filterRole="nursing" />} /> },
    { path: "psws", element: <ProtectedRoute children={<Employees filterRole="psw" />} /> },
    { path: "staff/:employeeId", element: <ProtectedRoute children={<DynamicEmployee />} /> },
    { path: "staff/application/:employeeId", element: <ProtectedRoute children={<DynamicApplication />} /> },
    { path: "staff/rating/:ratingId", element: <ProtectedRoute children={<DynamicRating />} /> },
    { path: "settings", element: <ProtectedRoute children={<Settings />} /> },
    { path: "requests", element: <ProtectedRoute children={<Requests />} /> },
    { path: "request/:requestId", element: <ProtectedRoute children={<DynamicRequest />} /> },
    { path: "chats", element: <ProtectedRoute children={<Chat />} /> },
    { path: "invite/:email", element: <ProtectedRoute children={<Invite />} /> },
    { path: "session/:sessionId", element: <ProtectedRoute children={<DynamicSession />} /> },
    { path: "payroll", element: <ProtectedRoute children={<Payroll />} /> },
    { path: "payroll/schedule", element: <ProtectedRoute children={<PayrollSchedule />} /> },
    { path: "payroll/account", element: <ProtectedRoute children={<PayrollAccount />} /> },
    { path: "payroll/account/card", element: <ProtectedRoute children={<PayrollSaveCard />} /> },
    { path: "payroll/run/:payrollId", element: <ProtectedRoute children={<PayrollSetup />} /> },
    { path: "payroll/:payrollId", element: <ProtectedRoute children={<PayrollDetails />} /> },
    { path: "invoice", element: <ProtectedRoute children={<Invoice />} /> },
    { path: "invoice/:invoiceId", element: <ProtectedRoute children={<InvoiceDetail />} /> },
    { path: "care-signals", element: <ProtectedRoute children={<CareSignals />} /> },
]